import React from 'react';

import NumberField from '../form/NumberField';
import TextField from '../form/TextField';
import { getCostPerIngredient } from '../../utilities/content/costCalculations';

const IngredientInput = ({ ingredient, index }) => {
  return (
    <div className="table-row">
      <TextField
        className="ingredient"
        name={`ingredients.${index}.name`}
        placeholder="Ingredient Name"
      />
      <TextField placeholder="Unit" name={`ingredients.${index}.unit`} />
      <NumberField
        name={`ingredients.${index}.amountPerPackage`}
        placeholder="Amount per package"
      />
      <NumberField
        name={`ingredients.${index}.costPerPackage`}
        placeholder="Cost per package"
      />
      <NumberField
        name={`ingredients.${index}.amountPerformula`}
        placeholder="Amount per formuma"
      />
      <span className="col">
        {getCostPerIngredient(ingredient)?.toFixed(2)}
      </span>
    </div>
  );
};

export default IngredientInput;
